import { FormsModule } from '@angular/forms';
import {
  MatInputModule,
  MatTooltipModule,
  MatExpansionModule
} from '@angular/material';
import { CommonFunctioModule } from './../common/commonFunction.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NoRecordsComponent } from './no-records/no-records.component';
import { GenericTableComponent } from './generic-table/generic-table.component';
import { GenericModalPopupComponent } from './generic-modal-popup/generic-modal-popup.component';
import { GenericGrandTableComponent } from './generic-grand-table/generic-grand-table.component';
import { GenericFetchingRecordsComponent } from './generic-fetching-records/generic-fetching-records.component';
import { GenericBeforedivListComponent } from './generic-beforediv-list/generic-beforediv-list.component';
import { GenericAttachmentComponent } from './generic-attachment/generic-attachment.component';
import { GenericApprovalsComponent } from './generic-approvals/generic-approvals.component';
import { GenericAfterdivListComponent } from './generic-afterdiv-list/generic-afterdiv-list.component';
import { GenericAccordionItemsComponent } from './generic-accordion-items/generic-accordion-items.component';
import { GenericAccordionAttachmentComponent } from './generic-accordion-attachment/generic-accordion-attachment.component';
import { GenericAccordionApprovalsComponent } from './generic-accordion-approvals/generic-accordion-approvals.component';
import { SharedModule } from '../shared/shared.module';
import { Md2TooltipModule, Md2TabsModule } from 'md2';
import { AllModuleModalPopupComponent } from './all-module-modal-popup/all-module-modal-popup.component';
import { AllModuleViewComponent } from './all-module-view/all-module-view.component';
import { DataProcessingStatusComponent } from './data-processing-status/data-processing-status.component';
import { AdditionalAttachmentComponent} from './additional-attachment/additional-attachment.component';
import { GenericProductEnquiryComponent } from './generic-product-enquiry/generic-product-enquiry.component';
import { AllocableCostTableComponent } from './allocable-cost-table/allocable-cost-table.component';

@NgModule({
  imports: [
    CommonModule,
    CommonFunctioModule,
    SharedModule,
    FormsModule,
    MatTooltipModule,
    Md2TooltipModule,
    MatInputModule,
    MatExpansionModule,
    Md2TabsModule,
  ],
  exports: [
    GenericAccordionApprovalsComponent,
    GenericAccordionAttachmentComponent,
    GenericAccordionItemsComponent,
    GenericAfterdivListComponent,
    GenericApprovalsComponent,
    GenericAttachmentComponent,
    GenericBeforedivListComponent,
    GenericFetchingRecordsComponent,
    GenericGrandTableComponent,
    GenericModalPopupComponent,
    GenericTableComponent,
    AllocableCostTableComponent,
    NoRecordsComponent,
    AllModuleModalPopupComponent,
    AllModuleViewComponent,  
     DataProcessingStatusComponent,  
     AdditionalAttachmentComponent,    
     GenericProductEnquiryComponent,
  
  ],
  declarations: [
    GenericAccordionApprovalsComponent,
    GenericAccordionAttachmentComponent,
    GenericAccordionItemsComponent,
    GenericAfterdivListComponent,
    GenericApprovalsComponent,
    GenericAttachmentComponent,
    GenericBeforedivListComponent,
    GenericFetchingRecordsComponent,
    GenericGrandTableComponent,
    GenericModalPopupComponent,
    GenericTableComponent,
    NoRecordsComponent,
    AllModuleModalPopupComponent,
    AllModuleViewComponent,
     DataProcessingStatusComponent,
     AdditionalAttachmentComponent,
     GenericProductEnquiryComponent,
     AllocableCostTableComponent,
  ],
  providers: []
})
export class GenericUiModule {}



// WEBPACK FOOTER //
// /codebuild/output/src516893352/src/src/app/generic-ui-components/generic.ui.module.ts